// Translation metrics
export const TRANSLATION_STRING_FAILURE = 'translation-string-failure';
export const STRING_ID_DIMENSION = 'stringId';
